// extracted by mini-css-extract-plugin
export default {"featuresContainer":"Features_featuresContainer__awrwV","cardGroup":"Features_cardGroup__i7mnu","card":"Features_card__+AjGL","specialCard":"Features_specialCard__CcUmQ"};